import React, { FC } from 'react';
import { useRenderers } from '../../../../../renderProps';
import { ExchangeRefundPriceDetails, ExchangeRefundPriceDetailsProps } from '@entities/order';

const RefundPricesWithOverride: FC<ExchangeRefundPriceDetailsProps> = props => {
	const { RefundPrices: RefundPricesOverride = ExchangeRefundPriceDetails } = useRenderers();

	return <RefundPricesOverride {...props} />;
};

export default RefundPricesWithOverride;
